// 示例数据
const rawData = `[{"createTime":"2024-06-07 11:32:35","tsAmount":663.00,"tsDate":"2024-06-07","tsDownstream":"安阳市善道明物资有限责任公司","tsId":821,"tsName":"PP注塑BU510","tsNumber":600.00,"tsUnitPrice":11055.00,"userId":1}, {"createTime":"2024-05-07 11:32:35","tsAmount":663.00,"tsDate":"2024-05-07","tsDownstream":"安阳市善道明物资有限责任公司","tsId":821,"tsName":"PP注塑BU510","tsNumber":600.00,"tsUnitPrice":11055.00,"userId":1}, {"createTime":"2023-06-07 11:32:35","tsAmount":663.00,"tsDate":"2023-06-07","tsDownstream":"安阳市善道明物资有限责任公司","tsId":821,"tsName":"PP注塑BU510","tsNumber":600.00,"tsUnitPrice":11055.00,"userId":1}]`
const data = JSON.parse(rawData)

// 工具函数：计算成交量
const calculateVolume = (data) => {
  return data.reduce((total, item) => total + item.tsNumber, 0)
}

// 比对函数：生成箭头（上升、下降、持平）
const compareVolumes = (current, previous) => {
  if (current > previous) {
    return 'up'
  } else if (current < previous) {
    return 'down'
  } else {
    return '='
  }
}

// 根据 tsName 分组数据
const groupByTsName = (data) => {
  return data.reduce((result, item) => {
    if (!result[item.tsName]) {
      result[item.tsName] = []
    }
    result[item.tsName].push(item)
    return result
  }, {})
}

// 处理函数：按当前日/月/年统计成交量
const processData = (data) => {
  const now = new Date()
  const currentYear = now.getFullYear()
  const currentMonth = String(now.getMonth() + 1).padStart(2, '0')
  const currentDay = String(now.getDate()).padStart(2, '0')
  const todayStr = `${currentYear}-${currentMonth}-${currentDay}`
  const currentMonthKey = `${currentYear}-${currentMonth}`

  // 前一天
  const yesterdayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
  const yesterdayStr = `${yesterdayDate.getFullYear()}-${String(yesterdayDate.getMonth() + 1).padStart(2, '0')}-${String(yesterdayDate.getDate()).padStart(2, '0')}`

  // 前一月
  const prevMonthDate = new Date(now.getFullYear(), now.getMonth() - 1, 1)
  const previousMonthKey = `${prevMonthDate.getFullYear()}-${String(prevMonthDate.getMonth() + 1).padStart(2, '0')}`

  const previousYear = currentYear - 1

  // 按 tsName 分组计算各周期成交量
  const calcPeriod = (filterFn) => {
    const filtered = data.filter(filterFn)
    const grouped = groupByTsName(filtered)
    const volumes = {}
    Object.keys(grouped).forEach(tsName => {
      volumes[tsName] = calculateVolume(grouped[tsName])
    })
    return volumes
  }

  const dayVolumes = calcPeriod(item => item.tsDate === todayStr)
  const prevDayVolumes = calcPeriod(item => item.tsDate === yesterdayStr)
  const monthVolumes = calcPeriod(item => {
    const m = item.tsDate ? item.tsDate.substring(0, 7) : ''
    return m === currentMonthKey
  })
  const prevMonthVolumes = calcPeriod(item => {
    const m = item.tsDate ? item.tsDate.substring(0, 7) : ''
    return m === previousMonthKey
  })
  const yearVolumes = calcPeriod(item => {
    const y = item.tsDate ? parseInt(item.tsDate.substring(0, 4)) : 0
    return y === currentYear
  })
  const prevYearVolumes = calcPeriod(item => {
    const y = item.tsDate ? parseInt(item.tsDate.substring(0, 4)) : 0
    return y === previousYear
  })

  // 收集所有出现过的产品名
  const allTsNames = [...new Set(data.map(item => item.tsName))]
  const result = []

  allTsNames.forEach(tsName => {
    const dayVol = dayVolumes[tsName] || 0
    const prevDayVol = prevDayVolumes[tsName] || 0
    const monthVol = monthVolumes[tsName] || 0
    const prevMonthVol = prevMonthVolumes[tsName] || 0
    const yearVol = yearVolumes[tsName] || 0
    const prevYearVol = prevYearVolumes[tsName] || 0

    result.push({
      tsName,
      period: '日',
      currentVolume: dayVol,
      previousVolume: prevDayVol,
      arrow: compareVolumes(dayVol, prevDayVol)
    })

    result.push({
      tsName,
      period: '月',
      currentVolume: monthVol,
      previousVolume: prevMonthVol,
      arrow: compareVolumes(monthVol, prevMonthVol)
    })

    result.push({
      tsName,
      period: '年',
      currentVolume: yearVol,
      previousVolume: prevYearVol,
      arrow: compareVolumes(yearVol, prevYearVol)
    })
  })

  return result
}

export function parse (data) {
  return processData(data)
}
// const result = processData(data);
// console.log(result);

// 输出结果示例：
// [
//   {
//     tsName: 'PP注塑BU510',
//     period: 'day',
//     currentVolume: 600,
//     previousVolume: 0,
//     arrow: '↑'
//   },
//   {
//     tsName: 'PP注塑BU510',
//     period: 'month',
//     currentVolume: 600,
//     previousVolume: 600,
//     arrow: '→'
//   },
//   {
//     tsName: 'PP注塑BU510',
//     period: 'year',
//     currentVolume: 600,
//     previousVolume: 600,
//     arrow: '→'
//   }
// ]
